import { render, staticRenderFns } from "./teacher_portrait.vue?vue&type=template&id=8c867e36&scoped=true"
import script from "./teacher_portrait.vue?vue&type=script&lang=js"
export * from "./teacher_portrait.vue?vue&type=script&lang=js"
import style0 from "./teacher_portrait.vue?vue&type=style&index=0&id=8c867e36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c867e36",
  null
  
)

export default component.exports